import { View } from "@react-pdf/renderer";
import { ResumePDFDescription } from "components/Resume/ResumePDF/common";
import { styles } from "components/Resume/ResumePDF/styles";
import type { ResumeCustom } from "lib/redux/types";
import { TemplateFourResumeSection } from "./common";

export const Custom = ({
  heading,
  custom,
  themeColor,
  enableMistakeHighlight = false,
}: {
  heading: string;
  custom: ResumeCustom;
  themeColor: string;
  enableMistakeHighlight?: boolean;
}) => {
  const { descriptions } = custom;

  return (
    <TemplateFourResumeSection themeColor={themeColor} heading={heading}>
      <View style={{ ...styles.flexCol }} wrap={false}>
        <ResumePDFDescription 
          items={descriptions} 
          enableMistakeHighlight={enableMistakeHighlight}
          section="custom"
          itemIndex={null}
        />
      </View>
    </TemplateFourResumeSection>
  );
};
